export default "__VITE_ASSET__DM$zheDM__"